import type { AxiosStatic } from 'axios'

export async function dynamicAxios<T>(callback: (axios: AxiosStatic) => T) {
  const axios = (await import('axios')).default
  return await callback(axios)
}
